export enum BettingGameTypeEnum {
    Subscribed = "subscribed",
    Promoted = "promoted",
    Public = "public",
    Owning = "owning",
}
